import React from 'react';
import Xing from 'oldAssets/images/icons/xing.svg';
import Linkedin from 'oldAssets/images/icons/linkedin-blue.svg';
import Email from 'oldAssets/images/icons/icon_email.png';
import SectionHeader from 'commonComponents/Headers/SectionHeader/SectionHeader';
import PhotoAndContact from '../Person/PhotoAndContact/PhotoAndContact';
import NameAndPosition from '../Person/NameAndPosition/NameAndPosition';
import styles from './Executives.module.scss';

const Executives = ({ title, managers }) => ( 
  <section className={ styles.Executives }>
    <SectionHeader
      title={ title }
      anchor='executives'
    />
    <div className={ styles.content }>
      { managers && managers.map((manager, i) => 
        <Manager
          key={ i }
          { ...manager }
        />
      ) }
    </div>
  </section>
);

const Manager = ({ photo, name, position, text, email, linkedin, xing }) => (
  <div className={ styles.Manager }>
    <PhotoAndContact
      size="300"
      employee={ { photo } }
      isManager={ true }
      contacts={[
        { icon: Email, link: `mailto:${email}` },
        { icon: Linkedin, link: linkedin },
        { icon: Xing, link: xing }
      ]}
    />
    <div className={ styles.managerInfo }>
      <NameAndPosition name={ name } position={ position } />
      <p>{ text }</p>
    </div>
  </div>
);
 
export default Executives;